var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a-icon',{staticStyle:{"margin-right":"8px"},attrs:{"type":_vm.type}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }